module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("gTCbY"))).then(() => parcelRequire('dJXJK'));